<template>
  <i :class="`mdi mdi-${icon} mdi-${size}px`" :style="{color: color}" />
</template>
<script>
export default {
  name: 'MdiIcon',
  data () {
    return {
      icon: this.$attrs.icon,
      size: this.$attrs.size || 24, // 18, 24, 36, 48
      color: this.$attrs.color || '#757575'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mdi-icon.vue